import React from 'react';

import { parseDateFromAPIFormat } from '../../common/format';
import { EndDateInlineEditor } from '../inline-edit/end-date';

export const EndDateColumn = ({ i18n, isReadOnlyUser, onInlineEditAssetGroup }) => ({
  key: 'EndDate',
  name: i18n.getString(_TL_('End date')),
  fieldName: ['StartDate', 'EndDate'],
  className: 'column-end-date',
  headerClassName: 'header-end-date',
  minWidth: 120,
  maxWidth: 200,
  sortKey: 'EndDate',
  sortable: true,
  isMultiline: true,
  isResizable: true,
  inlineEdit: item => !isReadOnlyUser && !item.isAggregatedRow,
  onRenderInlineEdit: (e, item, handleDismiss, cell, selector) => (
    <EndDateInlineEditor
      i18n={i18n}
      item={item}
      target={selector}
      onSave={onInlineEditAssetGroup}
      onDismiss={handleDismiss}
    />
  ),
  onRender: ({ EndDate }) => (
    <span>
      {parseDateFromAPIFormat(i18n, EndDate)}
    </span>
  ),
});
